<script setup lang="ts">
import { useAppStore } from '@/stores/app.store'
import PhIcon from '@/components/PhIcon.vue'
import ButtonNavbar from '@/components/button/ButtonNavbar.vue'

const { toggleSidebar } = useAppStore()
</script>

<template>
  <button-navbar @click="toggleSidebar" class="min-w-10">
    <ph-icon name="sidebar"></ph-icon>
  </button-navbar>
</template>

<style scoped></style>
